/**
 * Zod input schemas: profile. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
import { ChildSchema, EmergencyContactSchema } from './user.js';
/** Self-service profile edit — the fields an employee may maintain themselves
 *  (contact = personalData category, bank = bankDetails category). Enforced
 *  server-side via the access matrix (own-edit) per category. */
const optStr = (max) => z
    .union([z.string().trim().max(max), z.null(), z.undefined()])
    .transform((v) => (v == null || v === '' ? null : v));
export const SelfUpdateProfileSchema = z.object({
    // Contact (personalData)
    address: optStr(300),
    zipCode: optStr(20),
    city: optStr(120),
    country: optStr(2).transform((v) => (v ? v.toUpperCase() : v)),
    privatePhone: optStr(40),
    // Date of birth, YYYY-MM-DD (26 Oct 2026, mandatory profile): the person may set it only while it is
    // empty; after that HR changes it (enforced server-side in selfUpdateProfile).
    dateOfBirth: optStr(10),
    // Bank (bankDetails)
    accountOwnerName: optStr(200),
    iban: optStr(40),
    bicSwift: optStr(20),
    bankName: optStr(200),
    // Emergency contacts
    emergencyContacts: z.array(EmergencyContactSchema).max(6).optional(),
    // Children / dependents (self-editable only when the `children` field is
    // visible to the owner — enforced server-side in selfUpdateProfile).
    children: z.array(ChildSchema).max(20).optional(),
    // NOTE: `hubCommsUsePrivateEmail` is intentionally NOT self-editable — it is an
    // admin-only setting (set via adminUpdateUser / UserForm).
});
export const RequestPrivateEmailChangeSchema = z.object({
    email: z.string().trim().email().max(200),
});
export const VerifyPrivateEmailTokenSchema = z.object({
    token: z.string().trim().min(10).max(200),
});
//# sourceMappingURL=profile.js.map